module.exports = __webpack_public_path__ + "e3bd989ea7519a771f75d3426646eba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/3026_teaser_image.jpg
// module id = 616
// module chunks = 0